/**
 * EnergyConnect.WebApi | v1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const JobStatus = {
    Unknown: 'Unknown',
    Disabled: 'Disabled',
    Error: 'Error',
    Warning: 'Warning',
    Ok: 'Ok',
} as const;
export type JobStatus = typeof JobStatus[keyof typeof JobStatus];

